package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_paymentparameter_data_di_PaymentParameterModule : Module get() = module {
	single() { _ -> com.essntl.features.paymentparameter.data.repository.PaymentParameterRepositoryImpl(supabase=get()) } bind(com.essntl.features.paymentparameter.domain.repository.PaymentParameterRepository::class)
	single() { _ -> com.essntl.features.paymentparameter.data.supabase.PaymentParameterSupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.paymentparameter.data.supabase.PaymentParameterSupabaseDataSource::class)
}
public val com.essntl.features.paymentparameter.data.di.PaymentParameterModule.module : org.koin.core.module.Module get() = com_essntl_features_paymentparameter_data_di_PaymentParameterModule
